import { Catalogue, CatalogueItem } from '../../common';

export function getCatalogueWithoutCategoryChildren(catalogue: Catalogue): Catalogue {
  return {
    ...catalogue,
    products: catalogue.products
      .filter((product) => !product.device.productCategoryName || product.device.isProductCategory)
      .map((product, index) => {
        return {
          ...product,
          device: {
            ...product.device,
          },
          index: index,
        } as CatalogueItem;
      }),
  } as Catalogue;
}
